import { useCallback } from 'react';
import { useToggleState } from 'app/lib/hooks/useToggleState/useToggleState.js';

const AllowTypes = ['Files', 'application/json'];

export function useDropTargetState() {
    const [isVisible, , show, hide] = useToggleState(false);

    const onDragEnter = useCallback(
        (event) => {
            if (AllowTypes.some((type) => event.dataTransfer.types.includes(type))) {
                show();
            }
        },
        [show]
    );

    return {
        isVisible,
        hide,
        onDragEnter
    };
}
